import apiClient from './client';

export const listProjects = (params) => apiClient.get('/projects', { params }).then((r) => r.data);
export const getProject = (id) => apiClient.get(`/projects/${id}`).then((r) => r.data);
export const getProjectProgress = (id) => apiClient.get(`/projects/${id}/progress`).then((r) => r.data);
export const createProject = (payload) => apiClient.post('/projects', payload).then((r) => r.data);
export const updateProject = (id, payload) => apiClient.put(`/projects/${id}`, payload).then((r) => r.data);
export const deleteProject = (id) => apiClient.delete(`/projects/${id}`).then((r) => r.data);
export const addProjectNote = (id, note) => apiClient.post(`/projects/${id}/notes`, { note }).then((r) => r.data);
export const updateProjectStatus = (id, status) => apiClient.patch(`/projects/${id}/status`, { status }).then((r) => r.data);